module.exports = __webpack_public_path__ + "images/rewind.png";